import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Box, Link } from '@mui/material';
import useResponsive from '../../hooks/useResponsive';

// ----------------------------------------------------------------------

const WhiteLogo = forwardRef(({ disabledLink = false, sx, ...other }, ref) => {
  const isDesktop = useResponsive('up', 'lg');
  const WhiteLogo = (
    <Box
      ref={ref}
      component="div"
      sx={
        isDesktop
          ? {
              width: 200,
              height: 60,
              display: 'inline-flex',
              ...sx,
            }
          : { width: 200, height: 60, display: 'inline-flex', ...sx }
      }
      {...other}
    >
      <img
        src="https://acma-media-bucket.s3.us-east-2.amazonaws.com/images/brand/acma/logo-white%403x.png"
        alt="White logo"
      />
    </Box>
  );

  if (disabledLink) {
    return <>{WhiteLogo}</>;
  }

  return (
    <Link to="/" component={RouterLink} sx={{ display: 'contents' }}>
      {WhiteLogo}
    </Link>
  );
});

WhiteLogo.propTypes = {
  sx: PropTypes.object,
  disabledLink: PropTypes.bool,
};

export default WhiteLogo;
